const ROLE_ALIASES: Record<string, string> = {
  superuser: 'superadmin',
  'super-admin': 'superadmin',
  super_admin: 'superadmin',
  platform_superadmin: 'platform-superadmin',
  platform_admin: 'platform-admin',
  tenant_admin: 'tenant-admin',
  agent_developer: 'agent-developer',
};

export function normalizeUserRole(role: string): string {
  const normalized = role.trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(ROLE_ALIASES, normalized) ? ROLE_ALIASES[normalized] : normalized;
}

export function isSuperuserRole(role: string): boolean {
  return ['superadmin', 'platform-superadmin'].includes(normalizeUserRole(role));
}

export function isAdminRole(role: string): boolean {
  return isSuperuserRole(role) || ['admin', 'platform-admin'].includes(normalizeUserRole(role));
}

/**
 * Platform staff: the superadmin tier and platform-admin. Unlike isAdminRole
 * this leaves out `admin`, which the server treats as a tenant administrator
 * (the role self-signup hands a tenant's first person).
 */
export function isPlatformLevelRole(role: string): boolean {
  return isSuperuserRole(role) || normalizeUserRole(role) === 'platform-admin';
}
